import { ROSTERS_ACTIONS } from '.';

export const RostersActionTypes: ROSTERS_ACTIONS = {
  FETCH_ROSTERS_START: '[rosters] FETCH_ROSTERS_START',
  FETCH_ROSTERS_SUCCESS: '[rosters] FETCH_ROSTERS_SUCCESS',
  FETCH_ROSTERS_FAILURE: '[rosters] FETCH_ROSTERS_FAILURE',

  ADD_ROSTER_START: '[rosters] ADD_ROSTER_START',
  ADD_ROSTER_SUCCESS: '[rosters] ADD_ROSTER_SUCCESS',
  ADD_ROSTER_FAILURE: '[rosters] ADD_ROSTER_FAILURE',

  UPDATE_ROSTER_START: '[rosters] UPDATE_ROSTER_START',
  UPDATE_ROSTER_SUCCESS: '[rosters] UPDATE_ROSTER_SUCCESS',
  UPDATE_ROSTER_FAILURE: '[rosters] UPDATE_ROSTER_FAILURE',

  DELETE_ROSTER_START: '[rosters] DELETE_ROSTER_START',
  DELETE_ROSTER_SUCCESS: '[rosters] DELETE_ROSTER_SUCCESS',
  DELETE_ROSTER_FAILURE: '[rosters] DELETE_ROSTER_FAILURE',

  FETCH_ROSTER_STUDENTS_START: '[rosters] FETCH_ROSTER_STUDENTS_START',
  FETCH_ROSTER_STUDENTS_SUCCESS: '[rosters] FETCH_ROSTER_STUDENTS_SUCCESS',
  FETCH_ROSTER_STUDENTS_FAILURE: '[rosters] FETCH_ROSTER_STUDENTS_FAILURE',

  DELETE_ROSTER_STUDENT_START: '[rosters] DELETE_ROSTER_STUDENT_START',
  DELETE_ROSTER_STUDENT_SUCCESS: '[rosters] DELETE_ROSTER_STUDENT_SUCCESS',
  DELETE_ROSTER_STUDENT_FAILURE: '[rosters] DELETE_ROSTER_STUDENT_FAILURE',

  TOGGLE_ROSTER: '[rosters] TOGGLE_ROSTER',

  RESET_ROSTERS: '[rosters] RESET_ROSTERS'
};

export const ROSTERS_RESPONSE = 'RostersResponse';